import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-ZPQRLC9KQN'); 
};

export const logPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
